import script from "./HistoryFinances.vue?vue&type=script&lang=ts&setup=true"
export * from "./HistoryFinances.vue?vue&type=script&lang=ts&setup=true"

import "./HistoryFinances.vue?vue&type=style&index=0&id=0994d3a7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0994d3a7"]])

export default __exports__